/**
 * Phone-screen dimensions and behavioural constants for the visual menu editors.
 * All values are at "ratio 1" (i.e., iPhone 16 logical points) and scale by
 * `ratio = containerWidth / BASE_WIDTH` in the components.
 */

// iPhone 16 logical points (Apple's reference dimensions)
export const BASE_WIDTH  = 390
export const BODY_HEIGHT = 660

// Bar dimensions
export const HEADER_MIN_HEIGHT          = 56
export const FOOTER_MIN_HEIGHT_DEFAULT  = 56
export const FOOTER_MIN_HEIGHT_TABS     = 83

// Device chrome (status bar + home indicator) — extends the phone wrapper
// to read as a real device, not a floating screen.
export const STATUS_BAR_HEIGHT          = 22
export const STATUS_BAR_FONT_SIZE       = 13
export const STATUS_BAR_HORIZ_PADDING   = 18
export const HOME_INDICATOR_HEIGHT      = 22
export const HOME_INDICATOR_PILL_WIDTH  = 134
export const HOME_INDICATOR_PILL_HEIGHT = 5

// Wrapper styling
export const BORDER_RADIUS_BASE = 32

// Header content
export const HEADER_FONT_SIZE      = 14
export const HEADER_ICON_SIZE      = 20
export const HEADER_HORIZ_PADDING  = 14
export const HEADER_VERT_PADDING   = 10
export const HEADER_GAP            = 4

// Drag-and-drop edge auto-scroll
export const EDGE_SCROLL_ZONE_PX = 60
export const EDGE_SCROLL_MAX_PX  = 10

// Drag clone z-index (above any in-app overlay)
export const DRAG_CLONE_Z_INDEX = 9999

// Tabs editor: cell internals
export const TAB_ICON_SIZE         = 26
export const TAB_LABEL_FONT_SIZE   = 10
export const TAB_GAP_BETWEEN_PARTS = 3
export const TAB_VERT_PADDING      = 8
export const TAB_HORIZ_PADDING     = 4
